import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService as ConfigService } from '@cudirect/shared-ui-library';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  // TODO: Re-evaluate this service. This us pulling in the config.json, which is the same data thats available in environment.json
  private env: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private configData: any;
  private netWorkStatus?: boolean = null;

  // Using the new inject pattern instead of constructor injection
  private readonly http = inject(HttpClient);
  private readonly configService = inject(ConfigService);

  public setNetworkStatus(status: boolean) {
    this.netWorkStatus = status;
  }

  public getNetworkStatus(): boolean {
    return this.netWorkStatus;
  }
}
